/**
 * GrowthBook's hosted CDN. We point directly at it rather than proxying
 * through our own Fastly layer (gb.uppbeat.io) — see DEV-5902.
 */
export const apiHost = 'https://cdn.growthbook.io';
